export enum ErrorCode {
  NOT_FOUND = 'NOT_FOUND',
  SERVER_ERROR = 'SERVER_ERROR',
  SESSION_TIMEOUT = 'SESSION_TIMEOUT',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  BAD_REQUEST = 'BAD_REQUEST',
  EXTERNAL_API_TIMEOUT = 'EXTERNAL_API_TIMEOUT',
  KEYCLOAK_ERROR = 'KEYCLOAK_ERROR',
}
